import { render, staticRenderFns } from "./CustomerFollowLogFunction.vue?vue&type=template&id=51bca5fd"
import script from "./CustomerFollowLogFunction.vue?vue&type=script&lang=js"
export * from "./CustomerFollowLogFunction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports